<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Assign Device Vin</span>
    </div>
  </div>

  @if (isUploaded !== true) {
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Add Device Vin</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            (click)="downloadMyFile()"
            type="button"
          >
            Download Sample Excel Template
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <form [formGroup]="fileNameForm" novalidate>
          <div class="form-section">
            <!-- Device Vin File Upload -->
            <div class="form-group">
              <label for="fileName" class="form-label"
                >Device Vin File Upload</label
              >
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Device Vin File Upload</mat-label>

                <!-- Display File Name or Placeholder -->
                <input
                  matInput
                  type="text"
                  formControlName="fileName"
                  [value]="fileNameForm.controls['fileName'].value"
                  readonly
                />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".csv"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                <!-- Error Message -->
                @if (
                  fileNameForm.controls['fileName'].touched &&
                  fileNameForm.controls['fileName'].errors?.required
                ) {
                  <mat-error> This field is Mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section -->
      <div class="component-footer">
        <div class="button-group">
          <button
            type="button"
            [disabled]="!file"
            class="edit-button"
            (click)="saveDeviceVinConfigDetails($event)"
          >
            Upload <mat-icon class="btn-icon">edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
  @if (isUploaded === true) {
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Device Vin Uploaded Files Response</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            (click)="DownloadOutputReport()"
            [disabled]="Responses.length === 0"
            type="button"
          >
            Download Report
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>IMEI</th>
              <th>Vin</th>
              <th>Status</th>
            </tr>
          </thead>
          @if (totalLength !== 0) {
            <tbody>
              @for (
                response of Responses
                  | paginate
                    : {
                        id: 'paginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track response
              ) {
                <tr>
                  <td>{{ response.imei || '--' }}</td>
                  <td>{{ response.vin || '--' }}</td>
                  <td>{{ response.message }}</td>
                </tr>
              }
            </tbody>
          }
          @if (totalLength === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                    tabindex="0"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
